import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

const Footer = () => {
    return (
        <Container maxWidth="md">
            <Box sx={{ flexGrow: 1 , marginTop:"2rem" }}>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 , color:"rgba(255,255,255, 0.2)" , display:"flex" , justifyContent:"center" , fontSize:"14px" , marginBottom:"10px" }}> © 2022 omar hussain all rights Reserved </Typography>
            </Box>
        </Container>
    )
}
export default Footer;